import { H2, H4, P2, P3 } from '../../../styles/FontStyles';
import { Main, Section5Wrapper } from '../Home.styled';

import { colors, lightTheme } from '../../../styles/GlobalStyles';
import { Div, Img } from '../../../styles/Styles';

import image1 from '../../../assets/images/sec6Img1.png';
import image2 from '../../../assets/images/sec6Img2.png';
import image3 from '../../../assets/images/sec6Img3.png';
import Marquee from 'react-fast-marquee';
import { AnimatedDiv } from 'components/Animation/Animation';
import { useEffect, useState } from 'react';

const section6Data = [
  {
    title: '01 REGISTER FOR FREE:',
    description: 'Your Spot in Our Global Community',
    image: image1,
  },
  {
    title: '02 STAY INFORMED:',
    description: 'Get Updates on Our Official Launch and Upcoming Products',
    image: image2,
  },
  {
    title: '03 BE PART OF THE FUTURE:',
    description:
      'Access Exclusive Resources, Training, and Partnership Opportunities',
    image: image3,
  },
];
export const Section6 = () => {
  return (
    <Section5Wrapper id='section6'>
      <Main>
        <AnimatedDiv
          $flex
          $alignEnd
          $columnSM
          $centerSM
          $gap='40px'
          $gapSM='20px'
        >
          <Div $width='25%' $widthSM='100%'>
            <H2 mb='30' centerSM color={lightTheme.white}>
              One vision.
              <br /> One team.
              <br /> One future.
            </H2>
            <P2 mb='200' mbSM='24' color={lightTheme.white} centerSM>
              <br />
              Discover how you can be part of our global community and shape the
              future with us
            </P2>
          </Div>
          {section6Data.map((item, i) => (
            <Div
              key={i}
              $width={i === 0 ? '20%' : i === 1 ? '25%' : '30%'}
              $widthSM={i === 0 ? '60%' : i === 1 ? '75%' : '90%'}
              $flex
              $column
              $alignEnd
              $relative
              $mbSM='40'
            >
              <H4
                mb='0'
                mr='10'
                right
                fontFamily='Nulshock'
                color={colors.primary}
              >
                {item.title}
              </H4>
              <P3
                mb='60'
                mbSM='24'
                mr='10'
                right
                maxWidth='130px'
                color={lightTheme.white}
              >
                {item.description}
              </P3>
              <Img src={item.image} width='100%' alt='section5' />
              <Div $absolute $top='50px' $right='0'>
                <svg
                  width='2'
                  height='227'
                  viewBox='0 0 2 227'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <line
                    x1='1'
                    y1='-4.37114e-08'
                    x2='1.00001'
                    y2='226.513'
                    stroke='#AE8E66'
                    stroke-width='2'
                  />
                </svg>
              </Div>
            </Div>
          ))}
        </AnimatedDiv>
      </Main>
      <MarqueeComponent />
    </Section5Wrapper>
  );
};

export const MarqueeComponent = () => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return (
    <Div $mt='100px' $width='100%'>
      {isMounted && (
        <Marquee speed={100} delay={0}>
          {[
            'INNOVATION',
            'FUTURE',
            'VISION',
            'GLOBAL',
            'TECHNOLOGY',
            'INNOVATION',
            'FUTURE',
            'VISION',
            'GLOBAL',
            'TECHNOLOGY',
            'INNOVATION',
            'FUTURE',
            'VISION',
            'GLOBAL',
            'TECHNOLOGY',
            'INNOVATION',
            'FUTURE',
            'VISION',
            'GLOBAL',
            'TECHNOLOGY',
          ].map((item, i) => (
            <H4 key={i} m='20px 100px' mSM='10px 30px' color={lightTheme.white}>
              {item}
            </H4>
          ))}
        </Marquee>
      )}
    </Div>
  );
};
